module.exports = __webpack_public_path__ + "img/gift.6709e98b.png";